import { render, staticRenderFns } from "./OtherSupplierCategoryManage.vue?vue&type=template&id=69d1d230&scoped=true&"
import script from "./OtherSupplierCategoryManage.vue?vue&type=script&lang=js&"
export * from "./OtherSupplierCategoryManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d1d230",
  null
  
)

export default component.exports